export class DynamicMenuButton {
	event: any;
	matIcon: string;
	name: string;
	disabled?: boolean = false;
	condition?: string; // Hide/show button based on object property (boolean)
	hide?: boolean; // Hide/show button based on a flag
}
